import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { RiskControlOptions } from '@/common/constants';

const useRiskModels = (value?: RiskControlOptions) => {
  const { t } = useTranslation();
  const riskOptions = useMemo(
    () => [
      {
        label: t('Conservative Model'),
        value: RiskControlOptions.CONSERVATIVE,
      },
      {
        label: t('Moderately Conservative Model'),
        value: RiskControlOptions.MODERATELY_CONSERVATIVE,
      },
      {
        label: t('Moderate Model'),
        value: RiskControlOptions.MODERATE,
      },
      {
        label: t('Moderately Aggressive Model'),
        value: RiskControlOptions.MODERATELY_AGGRESSIVE,
      },
      {
        label: t('Aggressive Model'),
        value: RiskControlOptions.AGGRESSIVE,
      },
    ], [t],
  );
  const shortRiskOptions = useMemo(
    () => [
      {
        label: t('Conservative'),
        value: RiskControlOptions.CONSERVATIVE,
      },
      {
        label: t('Moderately Conservative'),
        value: RiskControlOptions.MODERATELY_CONSERVATIVE,
      },
      {
        label: t('Moderate'),
        value: RiskControlOptions.MODERATE,
      },
      {
        label: t('Moderately Aggressive'),
        value: RiskControlOptions.MODERATELY_AGGRESSIVE,
      },
      {
        label: t('Aggressive'),
        value: RiskControlOptions.AGGRESSIVE,
      },
    ], [t],
  );
  const currentOption = useMemo(
    () => riskOptions.find((item) => item.value === value) 
    ,[riskOptions, value]);
  const currentShortOption = useMemo(
    () => shortRiskOptions.find((item) => item.value === value) 
    ,[shortRiskOptions, value]);
  return {
    currentOption,
    currentShortOption,
    riskOptions
  };
};
export default useRiskModels;